import { useState } from "react";
import useContacts from "../../../services/chat/useContacts";
import ContactAdd from "./ContactAdd";

const ContactBook = ({ userID }) => {
  const { contacts, audience, loading } = useContacts(userID);
  const [selectedAudienceGroup, setSelectedAudienceGroup] = useState(null);
  const [filter, setFilter] = useState("contactbook");
  const [searchTerm, setSearchTerm] = useState("");

  const filterData = (data) => {
    return data.filter((item) => {
      const name = item.name || item.contact_name || "";
      const number = item.mobile || item.contact_number || "";

      return (
        name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        number.toLowerCase().includes(searchTerm.toLowerCase())
      );
    });
  };

  const displayedContacts = selectedAudienceGroup
    ? filterData(selectedAudienceGroup.members)
    : filterData(contacts);

  return (
    <div className="p-6 min-h-screen montserrat-font-1">
      {filter === "addnew" && (
        <>
          <button
            onClick={() => setFilter("contactbook")}
            className="bg-blue-500 text-white px-4 py-2 rounded mb-4"
          >
            Contact Book
          </button>

          <ContactAdd />
        </>
      )}

      {filter === "contactbook" && (
        <>
          {/* Header */}
          <div className="flex justify-between items-center mb-6 montserrat-font-1">
            <h2 className="text-xl font-semibold">
              {selectedAudienceGroup
                ? `Members of ${selectedAudienceGroup.audience_group_name}`
                : "Contact Book"}
            </h2>

            <div className="flex gap-3 montserrat-font-1">
              {/* Audience Dropdown */}
              <select
                className="border rounded px-3 py-2"
                onChange={(e) => {
                  const selectedId = e.target.value;

                  const selectedGroup = audience.find(
                    (group) => group.id === selectedId
                  );

                  setSelectedAudienceGroup(selectedGroup);
                }}
              >
                <option value="">All Contact List</option>

                {audience.map((group) => (
                  <option key={group.id} value={group.id}>
                    {group.audience_group_name}
                  </option>
                ))}
              </select>

              {/* Search */}
              <input
                type="text"
                placeholder="Search..."
                className="border rounded px-3 py-2"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />

              {/* Add Button */}
              <button
                onClick={() => setFilter("addnew")}
                className="bg-green-500 text-white px-4 py-2 rounded"
              >
                Add Contact
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="bg-white shadow rounded-lg overflow-hidden montserrat-font-1">
            <table className="w-full text-center">
              <thead className="bg-green-500 text-white">
                <tr>
                  <th className="p-3">S.No</th>
                  <th className="p-3">Contact Name</th>
                  <th className="p-3">Contact Number</th>
                  <th className="p-3">Action</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="4" className="p-6">
                      Loading...
                    </td>
                  </tr>
                ) : (
                  displayedContacts.map((item, index) => (
                    <tr key={index} className="border-b">
                      <td className="p-3">{index + 1}</td>

                      <td className="p-3">
                        {item.name || item.contact_name || "N/A"}
                      </td>

                      <td className="p-3">
                        {item.mobile || item.contact_number || "N/A"}
                      </td>

                      <td className="p-3 flex justify-center gap-4">
                        <button className="text-blue-500 hover:underline">
                          Edit
                        </button>

                        <button className="text-red-500 hover:underline">
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default ContactBook;